import React, { memo } from "react";
import Separator from "../../../../core/components/Separator.tsx";
import Divider from "../../../../core/components/Divider.tsx";

function CadastroViagenSectionTitle({ title }: { title: string }) {
	return (
		<div className="embarque-cadastro-section-title">
			<Separator size="xl" />
			<Divider direction="horizontal" borderColor="#ccc"/>
			<Separator size="xl" />
			<p className="dados-embarque-text">{title}</p>
			<Separator size="xl" />
		</div>
	);
}

export default memo(CadastroViagenSectionTitle);
